import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import handleRequestError from '../../utils/handleRequestError';

const initialState = {
    isLoading: true,
    allElectricityConsumption: [],
    electricityConsumptionById: [],
    filters: {
        startdate: null,
        enddate: null,
    },
    error: '',
};

export const fetchConsumptionElectricity = createAsyncThunk(
    'consumptionElectricity/fetchConsumptionElectricity',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/energy`, {
                params,
            });

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const fetchConsumptionElectricityById = createAsyncThunk(
    'consumptionElectricity/fetchConsumptionElectricityById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/energy/${id}`);

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const createConsumptionElectricity = createAsyncThunk(
    'hrStaff/createConsumptionElectricity',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_HOST_API_KEY}/energy`, data);

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const updateConsumptionElectricity = createAsyncThunk(
    'hrStaff/updateConsumptionElectricity',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_HOST_API_KEY}/energy`, data);

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const deleteConsumptionElectricity = createAsyncThunk(
    'hrStaff/deleteConsumptionElectricity',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_HOST_API_KEY}/energy`, {
                data
            });

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

const consumptionElectricitySlice = createSlice({
    name: 'consumptionElectricitySlice',
    initialState,
    reducers: {
        setFilters(state, action) {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters(state) {
            state.filters = {
                ...state.filters,
            };
        },
    },
    extraReducers(builder) {
        builder.addCase(fetchConsumptionElectricity.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchConsumptionElectricity.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.allElectricityConsumption = payload.data;
        });
        builder.addCase(fetchConsumptionElectricity.rejected, (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        });
        builder.addCase(fetchConsumptionElectricityById.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchConsumptionElectricityById.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.electricityConsumptionById = payload.data;
        });
        builder.addCase(fetchConsumptionElectricityById.rejected, (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        });
        builder.addCase(createConsumptionElectricity.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(createConsumptionElectricity.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(createConsumptionElectricity.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(updateConsumptionElectricity.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(updateConsumptionElectricity.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateConsumptionElectricity.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(deleteConsumptionElectricity.fulfilled, (state) => {
            state.isLoading = false;
            state.filters = { ...state.filters };
            state.error = '';
        });
        builder.addCase(deleteConsumptionElectricity.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(deleteConsumptionElectricity.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export const { setFilters, resetFilters } = consumptionElectricitySlice.actions;

export default consumptionElectricitySlice.reducer;

export const selectConsumptionElectricityFilters = (state) => state.consumptionElectricity.filters;
export const selectConsumptionElectricityData = (state) => state.consumptionElectricity.allElectricityConsumption;
export const selectConsumptionElectricityDataById = (state) => state.consumptionElectricity.electricityConsumptionById;
export const selectConsumptionElectricityLoading = (state) => state.consumptionElectricity.isLoading;
export const selectConsumptionElectricityError = (state) => state.consumptionElectricity.error;
